/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"+tCmYb":["Please see the KLS careers page"],"IEq7FD":["There are no openings at this time. Please check back later!"],"c1SGFK":["A student studying on their laptop"],"a6VeGO":["We’ve got an ambitious mission,<0/> but together we can achieve it."],"f5Bavy":["Every child deserves the chance to learn regardless of where they are or their circumstances."],"M1O3Jz":["View careers"],"kpkU+b":["View internships"],"90DNFq":["We’re driven by our community."],"6kNoE/":["Our students, teachers, and parents come from all walks of life and so do we. We hire great people from a wide variety of backgrounds, not just because it’s the right thing to do, but because it makes our company stronger. Valuing diversity, equity and inclusion not only matters, but is necessary for us to actualize our mission and truly impact the communities we serve."],"mzNNdJ":["Our core values"],"OxE71B":["Live and breathe learners"],"9wHubQ":["We deeply understand and empathize with our users. We leverage user insights, research, and experience to build content, products, services, and experiences that our users trust and love. Our success is defined by the success of our learners and educators."],"KmqO9t":["Take a stand"],"aLZcy/":["As a company, we have conviction in our aspirational point of view of how education will evolve. The work we do is in service to moving towards that point of view. However, we also listen, learn and flex in the face of new data, and commit to evolving this point of view as the industry and our users evolve."],"ZssxPt":["Embrace diverse perspectives"],"kTG7nT":["We are a diverse community. We seek out and embrace a diversity of voices, perspectives and life experiences leading to stronger, more inclusive teams and better outcomes. As individuals, we are committed to bringing up tough topics and leaning into different points of view with curiosity. We actively listen, learn and collaborate to gain a shared understanding. When a decision is made, we commit to moving forward as a united team."],"R4t/wh":["Work responsibly and sustainably"],"QNZxXg":["We understand that achieving our audacious mission is a marathon, so we set realistic timelines and we focus on delivery that also links to the bigger picture. As a non-profit, we are supported by the generosity of donors as well as strategic partners, and understand our responsibility to our finite resources. We spend every dollar as though it were our own. We are responsible for the impact we have on the world and to each other. We ensure our team and company stay healthy and financially sustainable."],"8sRe7V":["Deliver wow"],"+aJ9AL":["We insist on high standards and deliver delightful, effective end-to-end experiences that our users can rely on. We choose to focus on fewer things - each of which aligns to our ambitious vision - so we can deliver high-quality experiences that accelerate positive measurable learning with our strategic partners."],"6VUjJL":["Cultivate learning mindset"],"KQ62D1":["We believe in the power of growth for learners and for ourselves. We constantly learn and teach to improve our offerings, ourselves, and our organization. We learn from our mistakes and aren’t afraid to fail. We don't let past failures or successes stop us from taking future bold action and achieving our goals."],"BIVolB":["Bring out the joy"],"7NCD1N":["We are committed to making learning a joyful process. This informs what we build for our users and the culture we co-create with our teammates, partners and donors."],"JfRBej":["Meet our team"],"WegcZr":["Team photo from January 2020."],"5cRGvD":["Learn more about us"],"R5PEXy":["Our perks"],"0+pwor":["Competitive salaries"],"n1N1KR":["Health and wellness benefits"],"RTFmk7":["Flexible time off"],"ZReYkJ":["401(k) + matching"],"nShUZ3":["Affinity groups"],"8XwVD9":["Paid parental leave"],"/Exg2n":["Fun virtual events"],"qDJSlU":["Current openings"],"V+D/YP":["Careers"]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["ur","zh-hant","sk","sgn-us","is","fv","en-x-rtl","zu","xh","th","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["zh-hans","vi","uk","sr","ro","pl","or","nb","ko","km","ka","hy","fr","de","bn","uz","ta","sv","rw","ru","pt-pt","nl","my","mr","mn","lol","ky","kn","ja","it","id","gu","da","cs","az","te","ar"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
